var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { displayError } from '../Config/ApplicationConfig';
import { isHttpAuthenticationError, isHttpResponse } from '../Shared/HttpRequestExecutor';
import { LayoutCentral } from './LayoutCentral';
import { LoadingError } from './SplashScreens/LoadingError';
var ErrorTypes;
(function (ErrorTypes) {
    ErrorTypes[ErrorTypes["None"] = 0] = "None";
    ErrorTypes[ErrorTypes["Normal"] = 1] = "Normal";
    ErrorTypes[ErrorTypes["ChunkLoad"] = 2] = "ChunkLoad";
    ErrorTypes[ErrorTypes["AuthenticationError"] = 3] = "AuthenticationError";
})(ErrorTypes || (ErrorTypes = {}));
export var useError = function () {
    var _a = __read(useState(), 2), _ = _a[0], setError = _a[1];
    var throwError = function (err) {
        setError(function () {
            throw err;
        });
    };
    return throwError;
};
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false, errorMessage: '', errorType: ErrorTypes.None };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        var _a, _b;
        if (isHttpResponse(error)) {
            if (isHttpAuthenticationError(error)) {
                return {
                    hasError: true,
                    errorMessage: 'Authentication failure',
                    errorType: ErrorTypes.AuthenticationError
                };
            }
            else {
                return { hasError: true, errorMessage: (_a = error.statusText) !== null && _a !== void 0 ? _a : '', errorType: ErrorTypes.Normal };
            }
        }
        else if (/.(js|css)\)/g.test(error.message)) {
            return { hasError: true, errorMessage: 'Application outdated', errorType: ErrorTypes.ChunkLoad };
        }
        return { hasError: true, errorMessage: (_b = error.message) !== null && _b !== void 0 ? _b : '', errorType: ErrorTypes.Normal };
    };
    ErrorBoundary.prototype.componentDidCatch = function () {
        if (this.state.errorType === ErrorTypes.Normal)
            if (this.state.errorMessage)
                displayError(this.state.errorMessage);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            if (this.state.errorType === ErrorTypes.ChunkLoad) {
                return (React.createElement(LayoutCentral, null,
                    React.createElement(LoadingError, { message: 'The application has been updated.' })));
            }
            if (this.state.errorType === ErrorTypes.AuthenticationError) {
                return (React.createElement(LayoutCentral, null,
                    React.createElement(LoadingError, { message: 'Permission error occurred.', info: 'Please reload the page to update permissions.' })));
            }
            else {
                return (React.createElement(LayoutCentral, null,
                    React.createElement(LoadingError, null)));
            }
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
